<template>
    <div class="summary-card" :class="{ 'is-loading': loading }">
        <div class="summary-card-icon" :style="{ color: color }">
            <Icon :icon-class="icon" size="6" />
        </div>
        <div class="summary-card-body">
            <span class="summary-card-label">{{ label }}</span>
            <span class="summary-card-value" v-if="!loading"><KvAmount :value="value || 0" /></span>
            <KvSkeleton v-else width="110px" height="26px" style="border-radius: 6px; margin-top: 2px;" />
        </div>
    </div>
</template>

<script>
import Icon from "../../components/icon/icon.vue";
import KvSkeleton from "../../components/ui/kv-skeleton.vue";
import KvAmount from "../../components/ui/kv-amount.vue";

export default {
    name: "BalanceSummaryCard",
    components: { Icon, KvSkeleton, KvAmount },
    props: {
        label: { type: String, required: true },
        value: { type: Number, required: true },
        icon: { type: String, required: true },
        color: { type: String, default: "#6B7280" },
        loading: { type: Boolean, default: false }
    }
};
</script>

<style scoped lang="scss">
.summary-card {
    display: flex;
    align-items: center;
    gap: 16px;
    background: #FFFFFF;
    border: 1px solid #E2E8F0;
    border-radius: 16px;
    padding: 20px 24px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    min-width: 0;

    &.is-loading {
        pointer-events: none;
    }

    @media (max-width: 576px) {
        padding: 12px 14px;
        gap: 10px;
        border-radius: 12px;
    }
}

.summary-card-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    @media (max-width: 576px) {
        ::v-deep [class*="icon-size-"] {
            font-size: 20px !important;
            line-height: 20px !important;
        }
    }
}

.summary-card-body {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
}

.summary-card-label {
    font-size: 12px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #6B7280;
    line-height: 1.3;
    overflow-wrap: break-word;

    @media (max-width: 576px) {
        font-size: 10px;
        letter-spacing: 0.03em;
    }
}

.summary-card-value {
    font-family: "Sora", sans-serif;
    font-size: 24px;
    font-weight: 500;
    color: #111827; 
    line-height: 1.2;

    @media (max-width: 576px) {
        font-size: 17px;
    }
}
</style>
